import React, { FC, memo } from 'react';
import classNames from 'classnames';
import s from './index.module.scss';
import warning from './img/warning.png';

type Props = {
  error?: string;
  className?: string;
};

const ErrorMessage: FC<Props> = props => {
  const { error, className } = props;
  return <div className={classNames(s.error, className)}>
    <img src={warning} alt="warning" />
    <p>{error}</p>
    </div>;
};

export default memo(ErrorMessage);
